import PropTypes from 'prop-types';
import React from 'react';
import { Row, Col } from 'react-bootstrap';

const ScenarioViewHeader = ({ name }) => (
  <div>
    <Row>
      <Col sm={12}>
        <h3>
          {name}
        </h3>
      </Col>
    </Row>
    <br />
  </div>
);

ScenarioViewHeader.propTypes = {
  name: PropTypes.string,
};

export default ScenarioViewHeader;
